



















import type { DsrResource } from '@getaccept/lib-shared/src/library/types/dsr-resource';
import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';
import { TooltipPlacement } from '../../enums/tooltip-placement';

export default defineComponent({
  name: 'NameCell',
  props: {
    resource: {
      type: Object as PropType<DsrResource>,
      required: true,
    },
    tooltipPrefix: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const truncatedName = computed(() => LibraryHelper.getTruncatedText(props.resource.title, 120));

    return { truncatedName, TooltipPlacement };
  },
});
